export default {
  getLabelsLoaded (state) {
    return state.labelsLoaded
  },
  getSelectedTag (state) {
    return state.selectedTag
  },
  shouldShowErrorMessage (state) {
    return state.isInitialDataFetched && !state.articles[0]?.length
  },
  getSelectedKeyword (state) {
    return state.tagList.find(keyword => keyword.key === state.selectedTag)
  }
}
